/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Role pill
 */

import React from "react";
import { Badge } from "@lemonadetraining/web-ui";
import { IconStar } from "@tabler/icons-react";

import type { BoxAccess } from "@lemonadetraining/contracts";

/** The same union the access resolver ranks; never a second list of roles. */
export type PillRole = NonNullable<BoxAccess["displayRole"]>;

/**
 * Outline, not a colour fill: the word carries the meaning, so it survives both
 * themes and colour-blind readers. The star marks the one person whose access
 * nobody in the gym can change.
 */
const LABEL: Record<PillRole, string> = { owner: "Owner", admin: "Admin", coach: "Coach" };

const RolePill: React.FC<{ role?: PillRole }> = ({ role = "owner" }) => (
  <Badge variant="outline" className="gap-1">
    {role === "owner" && <IconStar className="size-3" aria-hidden="true" />}
    {LABEL[role]}
  </Badge>
);

export default RolePill;
